import { SpecialArticlePage } from '../components/SpecialArticlePage';

const POWER_SLUG = 'power';

export function PowerPage() {
  return <SpecialArticlePage slug={POWER_SLUG} hideArticleMeta />;
}
